































































































import Vue from 'vue'
import { getApps, AppConfig, AppSubSystemConfig } from '../config'
import DocumentLink from './DocumentLink.vue'
import LogoRenderer from '@rhitics/vue/components/QingmingLogo.vue'
import AppLayout from '@rhitics/vue/components/AppLayout.vue'
import { toRhitics } from '@rhitics/utils/links'

export default Vue.extend({
  name: 'Dashboard',

  components: {
    LogoRenderer,
    DocumentLink,
    AppLayout
  },

  data() {
    return {
      q: '',
      isLoading: false
    }
  },

  computed: {
    appsInDisplay(): Array<AppConfig | AppSubSystemConfig> {
      const allApps = getApps()

      const externalAppsHandler = apps => {
        const excludedApps = ['RHITICS']

        return apps
          .filter(app => !excludedApps.includes(app.name))
          .map(app => {
            app.type = 'external'
            return app
          })
      }

      const internalAppsHandler = apps => {
        return apps.map(app => {
          app.type = 'internal'
          return app
        })
      }

      const keywordHandler = app => {
        const keyword = this.q.toLowerCase()
        const { name, shortName, description } = app

        return (
          name.toLowerCase().includes(keyword) ||
          shortName.toLowerCase().includes(keyword) ||
          description.toLowerCase().includes(keyword)
        )
      }

      const external = externalAppsHandler(allApps['external'])
      const internal = internalAppsHandler(allApps['internal'])
      const all = [...external, ...internal]

      return all.filter(app => this.$auth.can(app.policy)).filter(keywordHandler)
    }
  },

  mounted() {
    if (!this.$auth.isLogin) this.toPage('login')
  },

  methods: {
    moveToFirstApp(e: Event) {
      e.preventDefault()

      const firstMatchedApp = this.appsInDisplay[0]

      if (!firstMatchedApp) return

      this.directToRoute(firstMatchedApp)
    },

    toPage(name, subPage = undefined) {
      toRhitics(name, subPage)
    },

    directToRoute(app: AppConfig | AppSubSystemConfig) {
      // @ts-ignore
      const { routes, prefix, shortName, isMoveToNewSite } = app
      const appUrl = prefix === ''
        ? process.env.VUE_APP_WEBSITE_DOMAIN
        : `${prefix}.${process.env.VUE_APP_WEBSITE_DOMAIN}`

      // 這是針對新版前端遷移的暫時解法
      if (isMoveToNewSite) {
        const subName = shortName.toLowerCase() 
        const siteUrl = `https://${process.env.VUE_APP_WEB2_DOMAIN}/${subName}`
        window.location.href = siteUrl;
        return
      }

      const isExternal = !routes

      if (isExternal) {
        if (process.env.NODE_ENV === 'production') {
          window.location.href = `https://${appUrl}`
        } else {
          alert(`Not serve yet.\nPlease run 'yarn serve ${shortName.toLowerCase()}' to see it.`)
        }
      } else {
        this.$router.push(routes[0].path)
      }
    }
  }
})
